import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { pageLink, pageTitleKey, pageTitleStorage } from '/storage/sessionStorage/currentModule';
import { history } from '/Router/history';
import { pageTitleToolkit } from '/store';

import { capitalizeFirstLetter, parsePath } from './helpers';

export const usePageTitle = () => {
  const currentEntityName = useSelector(pageTitleToolkit.selectors.currentEntityName);

  const [currentPath, setCurrentPath] = useState<string | undefined>();

  const getStaticTitle = (): string => {
    if (__CI_BRANCH__ === 'develop') {
      return 'DEV Portal';
    }

    if (__CI_BRANCH__ === 'staging') {
      return 'STG Portal';
    }

    return 'Portal';
  };

  const setTitle = (title: string): void => {
    const convertedTitle = capitalizeFirstLetter(title);
    const extendedTitle = `${title ? `${convertedTitle} | ` : ''}`;
    document.title = `${extendedTitle} ${getStaticTitle()}`;
    pageTitleStorage.set(pageTitleKey, convertedTitle);
    pageTitleStorage.set(pageLink, currentPath ?? window.location.href);
  };

  const setTitleByPath = (path: string) => {
    setCurrentPath(path);
    setTitle(parsePath(path, currentEntityName));
  };

  useEffect(() => {
    setTitleByPath(window.location.href);

    const unlisten = history.listen((location) => {
      setTitleByPath(location.pathname);
    });

    return () => {
      unlisten();
    };
  });
};

export const PageTitleUpdater = () => {
  usePageTitle();
  return null;
};
